import { RowReportDiagramGanttDto } from "@/dtos";
import { Administrator, Incidence } from "@/entities";
import { addTimeToDateTime, areDatesSame, formatWithoutSeconds, getMinutesFromTime, getOldestDateFromArray, getRecentDateFromArray, parseLowerLimit, parseToLocalDateFromUtc, parseToLocalDateTimeFromUtc, parseToUtcDate, parseUpperLimit, sumTimes } from "@/helpers/utilities";
import { DiagramGanttRow, DiagramGanttRowBar } from "@/ui/components/graphs/diagram-gantt/interfaces";

export const formatRowDiagramGanttIncidence = (incidences: Incidence[], administrators: Administrator[]) => {
    const result: DiagramGanttRow[] = [];

    for (const incidence of incidences) {
        const row: DiagramGanttRow = {
            label: incidence.code,
            bars: []
        }

        if (incidence.date_planification && incidence.date_estimated) {
            const planningRowBar: DiagramGanttRowBar = {
                start_date: formatWithoutSeconds(parseToLocalDateTimeFromUtc(parseLowerLimit(incidence.date_planification?.toString()))),
                finish_date: formatWithoutSeconds(parseToLocalDateTimeFromUtc(parseUpperLimit(incidence.date_estimated))),
                ganttBarConfig: {
                    id: incidence.id + '-' + 'planning',
                    immobile: true,
                    style: {
                        background: "#0635C9",
                        borderRadius: "2px",
                        color: "white"
                    }
                }
            }

            row.bars.push(planningRowBar);
        }


        for (const incidenceTime of incidence.incidence_times) {
            const minutes = getMinutesFromTime(incidenceTime.time_working);
            const incidenceTimeDate = parseToLocalDateTimeFromUtc(incidenceTime.date.toString());
            const finishDate = addTimeToDateTime(incidenceTimeDate, minutes, 'minute');
            const administrator = administrators.find(x => incidenceTime.administrator_id == x.id);

            const executionRowBar: DiagramGanttRowBar = {
                start_date: formatWithoutSeconds(incidenceTimeDate),
                finish_date: formatWithoutSeconds(finishDate),
                ganttBarConfig: {
                    id: incidenceTime.id + '-' + 'execution',
                    immobile: true,
                    style: {
                        background: administrator?.color ?? "#9BE8D9",
                        borderRadius: "2px",
                        color: "white"
                    }
                }
            }

            row.bars.push(executionRowBar);
        }

        result.push(row);
    }

    return result;
}

export const formatRowExportDiagramGanttIncidence = (incidences: Incidence[]): RowReportDiagramGanttDto[] => {
    return incidences.map(x => {
        const dateWorking = x.incidence_times.map(x => x.date);
        const timeWorking = x.incidence_times.map(x => x.time_working);

        const recentDateWorking = getRecentDateFromArray(dateWorking);
        const incidenceTime = x.incidence_times.find(y => areDatesSame(y.date.toString(), recentDateWorking, true));
        const minutes = getMinutesFromTime(incidenceTime?.time_working ?? '0');
        const finalDateWorkings = addTimeToDateTime(recentDateWorking, minutes, 'minutes');
        
        const row: RowReportDiagramGanttDto = {
            incidence: `(${x.code}) ${x.name}`,
            planning_date: x.date_planification ? parseToUtcDate(x.date_planification.toString()) : 'S/N',
            estimated_date: x.date_estimated ? parseToUtcDate(x.date_estimated.toString()) : 'S/N',
            execution_date: getOldestDateFromArray(dateWorking, false),
            finish_execution_date: finalDateWorkings,
            total_time_working: sumTimes(timeWorking)
        }

        return row;
    });
}